import React from "react";
import type {ContractData, ContractDataDisplay} from "../classes";
import {showContractFieldValue} from "../classes";
import {Divider, Grid, Typography} from "@mui/material";
import type {ContractFieldSpec} from "../data/ContractFields";
import {ContractEditField} from "./ContractEditField";

type Props = {
    title: string;
    icon: React.ReactNode | null;
    data: ContractData | undefined
    fields: ContractFieldSpec[]
}
/**
 * Almost exact copy of ContractViewDataBlock.tsx
 */
export const ContractEditDataBlock: React.FC<Props> = ({title, icon, data, fields}) => {
    if (fields.length === 0) return <></>;
    const values: { values: ContractDataDisplay[]; spec: ContractFieldSpec }[] = fields
        .map(spec => ({spec, values: showContractFieldValue(data, spec)}))
        .filter(v => v.values.length > 0);
    if (values.length === 0) return <></>;

    return (
        <Grid
            className="modal-row"
            container
            style={{
                margin: '1em 0',
                padding: '1em',
                background: '#F6F6F6',
                borderRadius: '5px',
                border: '1px groove #D1D6DD'
            }}>
            <Grid className="row-icon" size={1}>
                {icon}
            </Grid>
            <Grid className="row-title" size={11}>
                <Typography variant="h5" component="h5">
                    {title}
                </Typography>
            </Grid>
            <Grid className="row-content" size={12}>
                {values.map(({spec, values}, i, array) =>
                    <React.Fragment key={spec.field}>
                        <ContractEditField spec={spec} values={values}/>
                        {i < array.length - 1 ? <Divider/> : null}
                    </React.Fragment>
                )}
            </Grid>
        </Grid>
    );
};
